import type {
    AlfredItemStatus,
    AlfredItemStatusType,
} from "@@/shared/sections/alfred-item-status";

const currentAlfredItemStatus = (status: {
    type: AlfredItemStatusType;
    status?: AlfredItemStatusType;
}) => status.type ?? status?.status;
const isAlfredItemStatus = (
    status:
        | {
              type: AlfredItemStatusType;
              status?: AlfredItemStatusType;
          }
        | undefined
        | null,
    compareWithType: AlfredItemStatus["type"]
): boolean => {
    if (!status) {
        // If no product status, return false
        return false;
    }

    const statusType = currentAlfredItemStatus(status);
    return statusType === compareWithType;
};

const isAlfredItemActive = (
    status: AlfredItemStatus | undefined | null
): boolean => isAlfredItemStatus(status, "ACTIVE");
const isAlfredItemPaused = (
    status: AlfredItemStatus | undefined | null
): boolean => isAlfredItemStatus(status, "PAUSED");
const isAlfredItemDraft = (
    status: AlfredItemStatus | undefined | null
): boolean => isAlfredItemStatus(status, "DRAFT");
const isAlfredItemDancing = (
    // hihi
    status: AlfredItemStatus | undefined | null
): boolean => isAlfredItemStatus(status, "DANCING");

export {
    isAlfredItemStatus,
    isAlfredItemPaused,
    isAlfredItemActive,
    isAlfredItemDancing,
    isAlfredItemDraft,
    currentAlfredItemStatus,
};
